$(document).ready(function(){

    // $(document).on('click', '.column-main .abutton-select', function(e){
    //     e.preventDefault();

    //     var clicked = $(this);

    //     // Clear selected
    //     var booking_types = $('.booking_type.selected')
    //     booking_types.removeClass('selected');
        
    //     // Highlight Selected
    //     var booking_type = $(this).closest('.booking_type');
    //     booking_type.addClass('selected');

    //     // Retrieve Breadcrum
    //     var title = booking_type.find('.title').text();
    //     var price = booking_type.find('.price').text();
    //     var time = booking_type.find('.time').text();

    //     // Join Details
    //     var parts = [title];
    //     if (price !== ''){
    //         parts.push(price);
    //     }
    //     if (time !== ''){
    //         parts.push(time);
    //     }

    //     // Display Details
    //     var option_1 = $('.option-1');
    //     option_1.text(parts.join(' - '));
    //     option_1.removeClass('hidden');

    //     // Store session with ajax
    //     var csrftoken = $('[name=csrfmiddlewaretoken]').val();
    //     var booking_id = booking_type.attr('data-id');
    //     var booking_link = booking_type.attr('data-link');

    //     // Update Proceed button
    //     //$('.abutton').attr('href', booking_link);

    //     if ($(window).width() < 768){
    //         $('.column-main .abutton-select').removeClass('selected');
    //         $(clicked).addClass('selected');
    //     }

    //     $.ajax({
    //         url: '/appointment-booking/booking-type/set/' + booking_id + '/',
    //         type: 'POST',
    //         headers: {
    //             'X-CSRFToken': csrftoken,
    //             'X-Requested-With': 'XMLHttpRequest'
    //         },
    //         success: function(response) {
    //             console.log('Success:', response);

    //             if ($(window).width() < 768){
    //                 window.location.href = clicked.attr('href');
    //             }

    //             // Auto Proceed
    //             document.location.href = booking_link;

    //         },
    //         error: function(xhr, status, error) {
    //             console.error('Error:', error);
    //         }
    //     });
    // });

    $('.services input').change(function(){

        // Which Service Types are checked
        var checked_services = [];
        $('.services input:checked').each(function(){
            var name = $(this).attr('name');
            id = parseInt(name.substring(13));
            checked_services.push(id);
        });

        // Pass details of selection to session
        var csrftoken = $('[name=csrfmiddlewaretoken]').val();
        $.ajax({
            url: '/appointment-booking/service-types/set/',
            type: 'POST',
            headers: {
                'X-CSRFToken': csrftoken,
                'X-Requested-With': 'XMLHttpRequest'
            },
            contentType: 'application/json',
            data: JSON.stringify({
                checked_services: checked_services
            }),
            success: function (response) {

                // Update Showings & Numbers
                var total_types = $('.service-title').attr('data-total');
                var total_shown = (response.match(/<div class="booking_type/g) || []).length;

                if (total_types == total_shown){
                    $('.service-label .all').removeClass('hide');
                } else {
                    $('.service-label .all').addClass('hide');
                }
                $('.total-shown').text(total_shown);

                // Update List
                $('.column-main').html(response);
            },
            error: function(xhr, status, error) {
                console.error('Error:', error);
            }
        });

    });

    // $(document).on('click', '.team-row .abutton-select', function(e){
    //     e.preventDefault();

    //     // Disable previous selection
    //     var members = $('.team-row .member');
    //     members.removeClass('selected');

    //     // Enable new selection
    //     var member = $(this).closest('.member');
    //     member.addClass('selected');
    //     member_id = member.attr('data-id');
    //     member_link = member.attr('data-link');
        
    //     // Update Proceed button
    //     //$('.abutton').attr('href', member_link);

    //     // Retrieve Breadcrum
    //     var name = member.find('.name').text();
    //     var role = member.find('.role').text();

    //     var parts = [name];
    //     if (role !== ''){
    //         parts.push(role);
    //     }

    //     // Update Breadcrumb
    //     var option_2 = $('.option-2');
    //     option_2.text(parts.join(' - '));
    //     option_2.removeClass('hidden');

    //     if ($(window).width() < 768){
    //         members.removeClass('selected');
    //         member.addClass('selected');
    //     }

    //     // Store session with ajax
    //     var csrftoken = $('[name=csrfmiddlewaretoken]').val();
    //     $.ajax({
    //         url: '/appointment-booking/team-member/set/',
    //         type: 'POST',
    //         headers: {
    //             'X-CSRFToken': csrftoken,
    //             'X-Requested-With': 'XMLHttpRequest'
    //         },
    //         contentType: 'application/json',
    //         data: JSON.stringify({
    //             member_id: member_id
    //         }),
    //         success: function (response) {
    //             console.error('Success');
    //             if ($(window).width() < 768){
    //                 window.location.href = member.attr('data-link');
    //             }

    //             // Auto Proceed
    //             document.location.href = member_link;

    //         },
    //         error: function(xhr, status, error) {
    //             console.error('Error:', error);
    //         }
    //     });

    // });

    $("#openCalendar").on("click", function () {
        var btn = this;
        fp.open();

        setTimeout(function () {
            var rect = btn.getBoundingClientRect();
            var cal = fp.calendarContainer;

            cal.style.position = "fixed";

            if (window.innerWidth <= 768) {
                // Mobile: below button, right-aligned
                cal.style.top = (rect.bottom + 8) + "px";
                cal.style.left = (rect.right - cal.offsetWidth) + "px";
            } else {
                // Desktop: to the right of button, top-aligned
                cal.style.top = rect.top + "px";
                cal.style.left = (rect.right + 8) + "px";
            }
        }, 0);
    });

    $('.mobile-drop').click(function(){
        $('.services').toggleClass('open');
        if ($('.services').hasClass('open')){
            $('.mobile-drop i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
        } else {
            $('.mobile-drop i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        }
    });


    var selectedValue = $('input[name="register_account"]:checked').val();
    if (selectedValue == 'yes') {
        $('.fields-optional').css('display', 'flex');
    } else {
        $('.fields-optional').css('display', 'none');
    }

    $('input[name="register_account"]').on('change', function () {
        var selectedValue = $(this).val();
        if (selectedValue == 'yes') {
            $('.fields-optional').css('display', 'flex');
        } else {
            $('.fields-optional').css('display', 'none');
        }
    });

});